import { z } from 'zod'

/** The outbox tabs: everything, or one status (Queued includes nothing else; Sending shows under All). */
export const OUTBOX_TABS = ['all', 'FAILED', 'QUEUED', 'SUPPRESSED'] as const
export type OutboxTab = (typeof OUTBOX_TABS)[number]

/** The outbox's filters live in the URL (shareable, back-button safe); invalid values fall back. */
export const outboxSearchSchema = z.object({
  status: z.enum(['FAILED', 'QUEUED', 'SUPPRESSED']).optional().catch(undefined),
  q: z.string().trim().max(200).optional().catch(undefined),
  page: z.number().int().min(1).optional().catch(undefined),
})
export type OutboxSearch = z.infer<typeof outboxSearchSchema>

/** The template editor's address: which template is open (`/settings/message-templates?key=…`). */
export const templatesSearchSchema = z.object({
  key: z
    .string()
    .regex(/^[a-z][a-z0-9_]*(\.[a-z][a-z0-9_]*)*$/)
    .max(80)
    .optional()
    .catch(undefined),
})
export type TemplatesSearch = z.infer<typeof templatesSearchSchema>
